<template>
  <!-- permissions check -->
  <v-container>
    <v-row
      v-if="hasReadPermissions"
      v-resize="handleHeight"
    >
      <v-col
        cols="12"
        class="pa-0"
      >
        <div
          id="sheet"
          class="websheet"
        >
          <hmd-data-grid
            :style="`min-height:${windowHeight-265}px;`"
            :re-render-key="reRenderKey"
            :dataset-id="dataset.hmd_id"
            :tap="dataset.tap"
            :read-only="dataset.is_readonly"
            export-btn
            choose-columns-to-show
            :live-scroll="false"
            @tapExecutionFinished="tapExecutionFinished"
          />
        </div>
      </v-col>
    </v-row>
    <template v-else>
      <new-jumbotron :my-jumbotron="myJumbotron" />
    </template>
  </v-container>
  <!-- Dialog for delete validation END -->
</template>

<script>
  import NewJumbotron from '../../../UIComponents/Jumbotron.vue'
  import HmdDataGrid from '../../../UIComponents/HmdDataTable/Grid'
  // import {AgGridVue} from "ag-grid-vue"

  export default {
    components: {
      NewJumbotron,
      HmdDataGrid,
      // AgGridVue,
    },
    props: {
      reRenderKey: {
        type: Number,
        default: () => { return 0 },
      },
      dataset: {
        type: Object,
        default: () => {
          return {
            name: '',
            description: '',
            updated_at: '',
            type: '',
            is_readonly: '',
            hmd_id: '',
            tap:'',
          }
        },
      },
      headerCellProp: {
        type: Array,
        default: function () {
          return []
        },
      },
      tableDataProp: {
        type: Array,
        default: function () {
          return []
        },
      },
      totalItemsProp: {
        type: Number,
        default: function () {
          return 0
        },
      },
      loadingProp: {
        type: Boolean,
        default: function () {
          return true
        },
      },
      userPermissions: {
        type: Array,
        default: function () {
          return []
        },
      },
      permissions: {
        type: Array,
        default: function () {
          return []
        },
      },
      index: Number,
    },
    data: function () {
      return {
        windowHeight: window.innerHeight,
        search: '',
        pagination: {
          descending: false,
          page: 1,
          rowsPerPage: 20,
          sortBy: null,
          totalItems: 0,
        },
        myJumbotron: {
          type: 'accessRequest',
          heading: "You don't have access to this information",
          subheading: 'Ask the owner to give you the permissions to access this dataset.',
          elementList: [
            { text: 'simple READ access' },
            { text: 'READ and WRITE access' },
            { text: 'READ, WRITE and MANAGE access' },
          ],
          dividerHeading: 'Ask for an access now!',
        },
        selectOptions: [
          {
            type: 'pk',
            selectValues: [
              { text: 'equals', value: 'equals' },
            ],
          },
          {
            type: 'ascii',
            selectValues: [
              { text: 'equals', value: 'equals' },
            ],
          },
          {
            type: 'text',
            selectValues: [
              { text: 'equals', value: 'equals' },
            ],
          },
          {
            type: 'boolean',
            selectValues: [
              { text: 'true', value: 'true' },
              { text: 'false', value: 'false' },
            ],
          },
          {
            type: 'int',
            selectValues: [
              { text: 'equals', value: 'equals' },
              { text: 'smaller than', value: 'lte' },
              { text: 'greater than', value: 'gte' },
              { text: 'between', value: 'range' },
            ],
          },
          {
            type: 'float',
            selectValues: [
              { text: 'smaller than', value: 'lte' },
              { text: 'greater than', value: 'gte' },
              { text: 'between', value: 'range' },
            ],
          },
          {
            type: 'date',
            selectValues: [
              { text: 'before', value: 'before' },
              { text: 'after', value: 'after' },
              { text: 'between', value: 'range' },
            ],
          },
          {
            type: 'timestamp',
            selectValues: [
              { text: 'before', value: 'lte' },
              { text: 'after', value: 'gte' },
              { text: 'between', value: 'range' },
            ],
          },
          {
            type: 'inet',
            selectValues: [
              { text: 'contains', value: 'in' },
              { text: 'does not contain', value: 'not_in' },
              { text: 'equals', value: 'equals' },
              { text: 'not equal', value: 'not_equals' },
            ],
          },
        ],
        dialogValidDelete: false,
        dialogEdit: false,
        dialogValidEdit: false,
        dialogInsert: false,
        dialogValidInsert: false,
        newRow: {},
        selectedRow: null,
        updatedRow: null,
        deletePrimaryKey: null,
      }
    },
    computed: {
      shownColumns () {
        const array = this.headerCell.filter(x => x.shown === true)
          .sort((a, b) => a.pk && !b.pk ? -1 : 1)

        // TODO: use push instead of unshift to get the buttons on the right side
        // console.log("==>"+this.dataset.user_permissions)

        if (!this.dataset.is_readonly &&
          (this.dataset.user_permissions === 'read_write_dataset' || this.dataset.user_permissions === 'owner_dataset')) {
          const elem = {
            value: 'Actions',
            sortable: false,
            isFiltering: false,
            isAction: true,
          }

          array.unshift(elem)
        }

        return array
      },
      headerCell () {
        return this.headerCellProp
      },
      tableData () {
        return this.tableDataProp
      },
      totalItems () {
        return this.totalItemsProp
      },
      loading () {
        return this.loadingProp
      },
      rowData: function () {
        const res = []

        return res
      },
      hasOwnerPermissions () {
        return this.dataset.user_permissions.includes('owner_dataset') || this.dataset.user_permissions.includes('owner_project')
      },
      hasWritePermissions () {
        return this.hasOwnerPermissions || this.dataset.user_permissions.includes('read_write_dataset') || this.dataset.user_permissions.includes('read_write_project')
      },
      hasReadPermissions () {
        return this.hasWritePermissions || this.dataset.user_permissions.includes('read_dataset') || this.dataset.user_permissions.includes('read_project')
      },
    },
    watch: {
      loading: function () {
        if (this.loading) {
          this.sendQuery()
        }
      },
      'pagination.page': {
        handler () {
          this.$emit('loading', true)
        },
      },
    },
    methods: {
      handleHeight (e) {
        if (e) { this.windowHeight = e.target.innerHeight }
      },
      getSelectOptions (type) {
        var el = this.selectOptions.find(x => x.type === type)
        return el
      },
      tapExecutionFinished(){
        this.$emit("tapExecutionFinished")
      },
      sendQuery () {
        var item
        var query = []
        for (item in this.headerCell) {
          if (this.headerCell[item].type === 'boolean') {
            this.headerCell[item].query.operator = 'equals'
          }
          if (this.headerCell[item].isFiltering) {
            query.push({
              field_name: this.headerCell[item].value,
              query: this.headerCell[item].query,
              is_shown: this.headerCell[item].shown,
              is_filtered: this.headerCell[item].isFiltering,
            })
          }
        }
        return new Promise((resolve, reject) => {
          var t = this
          const { sortBy, descending, page, rowsPerPage } = this.pagination

          // ToDo : Following will probably be useless
          // let n = rowsPerPage/2 * page
          // let resPage = Math.ceil(1/4 * (2 * (n/10) + Math.pow(-1, (n/10) + 1)))
          // console.log(this.pagination)
          // console.log(page === resPage)

          this.$emit('sendQuery', { query, page })
          const total = this.totalItems
          let items = this.tableData

          if (rowsPerPage > 0) {
            items = items.slice((page - 1) * rowsPerPage, page * rowsPerPage)
          }
        })
        this.$emit('loading', false)
      },
      isModified: function () {
        return Object.keys(this.updatedRow).some(key => {
          return (this.updatedRow[key] != this.selectedRow[key])
        })
      },
    },
  }
</script>
